import { DateType, ReportResultType } from "../../Shared/enum";
import { PaginationInfo } from "./PaginationInfo";
import { ReportFilter } from "./ReportFilter";

export class GenericReportCriteria {
  FromDate: Date;
  ToDate: Date;
  Filters: ReportFilter[];
  ResultType: ReportResultType;
  DetailMode: boolean;
  OrgId: number;
  UnitId: number;
  PaginationInfo: PaginationInfo;
  SortField: string;
  CriteriaDateType: DateType;
}
